var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const SeparatorCore = (props) => {
    const { color, weight, spacing, align, fullWidth, children, className, content, element: Element = 'div' } = props, rest = __rest(props, ["color", "weight", "spacing", "align", "fullWidth", "children", "className", "content", "element"]);
    const BEM = () => {
        const classArray = ['separator'];
        if (color) {
            classArray.push(`separator--color-${color}`);
        }
        if (weight) {
            classArray.push(`separator--${weight}`);
        }
        if (spacing) {
            classArray.push(`separator--${spacing}`);
        }
        if (align) {
            classArray.push(`separator--${align}`);
        }
        if (fullWidth) {
            classArray.push('separator--full-width');
        }
        if (children) {
            classArray.push('separator--content');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const TopElement = Element === 'span' ? 'span' : 'div';
    if (children) {
        return (React.createElement(TopElement, Object.assign({ className: BEM() }, rest),
            Element === 'hr' && React.createElement(Element, { className: "sr-only" }),
            React.createElement(TopElement, { className: "separator__content" }, children)));
    }
    if (content) {
        return (React.createElement(TopElement, Object.assign({ className: BEM() }, rest),
            Element === 'hr' && React.createElement(Element, { className: "sr-only" }),
            content));
    }
    return React.createElement(Element, Object.assign({ className: BEM() }, rest));
};
export { SeparatorCore as default };
